import firebase from 'firebase';
import {
    stagConfig,
    prodConfig
} from './config';

// USER TEST CONFIG TO ACCESS CLOUD TEST CLOUD FUNCTIONS, DATABASE, STORAGE ETC
if (process.env.REACT_APP_ENV === 'production') {
    firebase.initializeApp(prodConfig);
    // console.log('ENVIRONMENT VARIABLES', process.env);
}

if (process.env.REACT_APP_ENV === 'staging' || process.env.REACT_APP_ENV === 'testing') {
    firebase.initializeApp(stagConfig);
    // console.log('ENVIRONMENT VARIABLES', process.env);
}

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();

googleAuthProvider.addScope('profile, email');

const isStaging = process.env.REACT_APP_ENV === 'staging';

export {
    googleAuthProvider,
    facebookAuthProvider,
    isStaging,
    firebase as
    default
};


// WEBPACK FOOTER //
// ./src/js/firebase/firebase.js